import React, { useState } from 'react';
import { GraphView } from './RecipeGraph';
import { parseDuration } from '../utils/time';
import './RecipeView.css';

function IngredientPanel({ recipe }) {
    const yieldElements = [];
    const ingredientElements = [];

    if (recipe.yields && recipe.yields.length > 0) {
        for (let i = 0; i < recipe.yields.length; i++) {
            const yieldItem = recipe.yields[i];
            yieldElements.push(
                <li key={i}>
                    {yieldItem.amount ? `${yieldItem.amount} ` : ''}
                    {yieldItem.unit ? `${yieldItem.unit} ` : ''}
                    {yieldItem.name || yieldItem}
                </li>
            );
        }
    }

    if (recipe.ingredients && recipe.ingredients.length > 0) {
        for (let i = 0; i < recipe.ingredients.length; i++) {
            const ing = recipe.ingredients[i];
            ingredientElements.push(
                <li key={i}>
                    {ing.amount} {ing.unit} {ing.name}
                </li>
            );
        }
    }

    return (
        <div className="ingredients-panel">
            {recipe.total_time > 0 && (
                <>
                    <h3>Total Time</h3>
                    <ul className="yields-list">
                        <li>{parseDuration(recipe.total_time)}</li>
                    </ul>
                </>
            )}
            {yieldElements.length > 0 && (
                <>
                    <h3>Yields</h3>
                    <ul className="yields-list">
                        {yieldElements}
                    </ul>
                </>
            )}
            {ingredientElements.length > 0 && (
                <>
                    <h3>Ingredients</h3>
                    <ul className="ingredients-list">
                        {ingredientElements}
                    </ul>
                </>
            )}
        </div>
    );
}

export { IngredientPanel };

export default function RecipeView({ recipe }) {
    const [activeTab, setActiveTab] = useState('steps');

    return (
        <div className="recipe-view">
            <div className="recipe-view-header">
                <div className="recipe-title">{recipe.name}</div>
                <div className="recipe-view-tabs">
                    <button
                        className={`recipe-tab ${activeTab === 'ingredients' ? 'active' : ''}`}
                        onClick={() => setActiveTab('ingredients')}
                    >
                        Ingredients
                    </button>
                    <button
                        className={`recipe-tab ${activeTab === 'steps' ? 'active' : ''}`}
                        onClick={() => setActiveTab('steps')}
                    >
                        Steps
                    </button>
                </div>
            </div>
            <div className="recipe-tab-content">
                {activeTab === 'ingredients' ? (
                    <IngredientPanel recipe={recipe} />
                ) : (
                    <div className="graph-container">
                        <GraphView recipe={recipe} />
                    </div>
                )}
            </div>
        </div>
    );
}
